import { render } from "./OlyoCheckbox.vue?vue&type=template&id=5883c306&scoped=true"
import script from "./OlyoCheckbox.vue?vue&type=script&lang=js"
export * from "./OlyoCheckbox.vue?vue&type=script&lang=js"

import "./OlyoCheckbox.vue?vue&type=style&index=0&id=5883c306&scoped=true&lang=css"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5883c306"]])

export default __exports__